import {
  Accordion,
  AccordionItem as ReachAccordionItem,
  AccordionButton as ReachAccordionButton,
  AccordionPanel,
} from '@reach/accordion';
import '@reach/accordion/styles.css';
import IconPlusCircle from '@remote-com/norma/icons/plus-circle.svg';
import IconPlus from '@remote-com/norma/icons/plus.svg';
import styled from 'styled-components';

import { fluidProp } from '../../style/helpers';
import { sharedTransition } from '../../style/motion';

export { Accordion, AccordionPanel };

export const AccordionItem = styled(ReachAccordionItem)`
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: rgba(119, 140, 163, 0.3);
  ${fluidProp(['padding-top', 'padding-bottom'], '14px', '32px')}

  & + & {
    border-top: 0;
  }
`;

const AccordionTitle = styled.h2`
  ${({ theme }) => theme.typography.bodyLeadBold};
`;

export const AccordionButton = styled(ReachAccordionButton)`
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  background: none;
  font: inherit;
  color: inherit;
  padding: 0;
  text-align: left;
`;

const AccordionLabel = styled.span`
  flex-grow: 1;
  width: min-content;
`;

export const AccordionPosition = styled.span`
  --size: 1.375em;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.125em solid ${({ theme }) => theme.colors.darkBlue_30};
  width: var(--size);
  height: var(--size);
  font-weight: 600;
  font-size: 0.75em;
  line-height: var(--size);
  border-radius: 50%;
  margin-right: 1em;
  flex-shrink: 0;
`;

const AccordionIcon = styled.span`
  display: flex;
  margin-right: 1em;
`;

export const AccordionStatus = styled(IconPlusCircle)`
  ${sharedTransition('transform')}
  margin-left: 10px;
  width: 22px;
  height: 22px;
  color: var(--colors-irisBlue);
  flex-shrink: 0;

  [data-state='open'] & {
    transform: rotate(45deg);
  }
`;

export const SecondaryAccordionStatus = styled(IconPlus)`
  ${sharedTransition('transform')}
  margin-left: 10px;
  width: 22px;
  height: 22px;
  color: var(--colors-irisBlue);
  flex-shrink: 0;

  [data-state='open'] & {
    transform: rotate(45deg);
  }
`;

export const AccordionHeader = ({
  children,
  position,
  icon,
  secondaryStatusIcon = false,
  ...props
}) => (
  <AccordionTitle {...props}>
    <AccordionButton>
      {position && <AccordionPosition>{position}</AccordionPosition>}
      {icon && <AccordionIcon>{icon}</AccordionIcon>}
      <AccordionLabel>{children}</AccordionLabel>
      {secondaryStatusIcon ? <SecondaryAccordionStatus /> : <AccordionStatus />}
    </AccordionButton>
  </AccordionTitle>
);
